// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1u1T-","title":"AfterFrontImage_title__3OyIo"};